import React from "react"

import SyncOutfitterAssistantPathname from "~components/outfitter-assistant/sync-outfitter-assistant-pathname"
import PageLayout from "~components/shared/page-layout/page-layout"
import GlobalAuthentication from "~components/shared/global-authentication"
import SelfOnboardRedirect from "~components/self-onboard/common/self-onboard-redirect"

interface Props {
    readonly element: React.ReactNode
    readonly props: { location: Location }
}

export default function WrapPageElement({ element, props }: Props) {
    const { pathname } = props.location
    const isSelfOnboard = pathname.includes("self-onboard")

    const content = isSelfOnboard ? (
        element
    ) : (
        <SelfOnboardRedirect>
            <PageLayout>{element}</PageLayout>
        </SelfOnboardRedirect>
    )

    return (
        <GlobalAuthentication>
            <SyncOutfitterAssistantPathname pathname={pathname} />
            {content}
        </GlobalAuthentication>
    )
}
